module.exports = __webpack_public_path__ + "static/media/speaking.b975169e.svg";